import React from 'react';
import { UserRoundCheck, ShoppingCart, MailCheck } from 'lucide-react';

const Util = require('es6!sumo/util');
const Constants = require('es6!launcher/util/listbuilder/constants');

const { EVENT_SOURCE_TYPES, MEDIA_TYPES } = Constants;
const ICON_COLOR_DEFAULT = 'white';

const SocialProofSVG = ({
  styles,
  svg,
  iconColor = ICON_COLOR_DEFAULT,
  mediaId,
  mediaType,
  api,
}) => {
  const stylesJSON = styles.toJS();

  // If we have a media ID, show the uploaded image
  if (mediaId && mediaType === MEDIA_TYPES.IMAGE && api) {
    const imageUrl = Util.getMediaUrl(api, mediaId);
    return (
      <div className="sumome-react-wysiwyg-component bdow-sp-icon-svg" style={stylesJSON}>
        <img
          src={imageUrl}
          alt="Social proof icon"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: stylesJSON.borderRadius || '0px',
          }}
        />
      </div>
    );
  }

  // Otherwise, show the icon
  const getIcon = (type, color) => {
    switch (type) {
      case EVENT_SOURCE_TYPES.LEAD_SOURCE:
        return <UserRoundCheck size={40} stroke={color} />;
      case EVENT_SOURCE_TYPES.ECOMMERCE_SOURCE:
        return <ShoppingCart size={38} stroke={color} />;
      case EVENT_SOURCE_TYPES.ZAPIER_SOURCE:
        return <MailCheck size={38} stroke={color} />;
      case EVENT_SOURCE_TYPES.CUSTOM_SOURCE:
        return <MailCheck size={38} stroke={color} />;
      default:
        return <UserRoundCheck size={40} stroke={color} />;
    }
  };

  const iconElement = getIcon(svg, iconColor);

  return (
    <div className="sumome-react-wysiwyg-component bdow-sp-icon-svg" style={stylesJSON}>
      {iconElement}
    </div>
  );
};

export default SocialProofSVG;